export default __webpack_public_path__ + "static/media/VERRERIE ET CONSOMMABLE DE LABO.88d005ad.svg";